module.exports = __webpack_public_path__ + "static/media/icon_interactions_on.373a1d67.png";